import { Primer } from '@primer-io/checkout-web';
import { reactive, Ref, ref } from 'vue';

import { getUniqNumber } from '@/helpers/number';
import { usePromiseState } from '@/hooks/use-promise-state/use-promise-state';
import { PaymentStatePackage } from '@/pages/payment/store/payment-state';
import { getPrimerAuthorizeForm, getPrimerPaymentForm } from '@/services/api/payment/payment-api';

type UseSelfArg = {
  pkg: Ref<PaymentStatePackage>;
  isAuthorizeCardToken: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useSelf(arg: UseSelfArg) {
  // Ref -----------------------------------------------------------------------
  const clientToken = ref<string | null>(null);
  const primerCardElId = 'mma-pr-form-container' + getUniqNumber();

  // Hook ----------------------------------------------------------------------
  const { load, isLoaded } = usePromiseState();

  // Computed ------------------------------------------------------------------
  async function fetchClientToken() {
    const response = await load(
      arg.isAuthorizeCardToken
        ? getPrimerAuthorizeForm({
            paymentSource: '',
          })
        : getPrimerPaymentForm({
            package: {
              id: arg.pkg.value.id,
              offerId: arg.pkg.value.offer?.id ?? '',
            },
            paymentSource: '',
          }),
    );

    clientToken.value = response.sessionToken;
  }

  // Method --------------------------------------------------------------------
  async function mount() {
    await fetchClientToken();

    if (!clientToken.value) {
      return;
    }
    await Primer.showUniversalCheckout(clientToken.value, {
      container: '#' + primerCardElId,
      vault: {
        visible: false,
      },
      onCheckoutComplete(...args) {
        console.log('onCheckoutComplete', ...args);
      },
    });
  }

  return reactive({ isLoaded, primerCardElId, mount });
}
